import i18next from 'i18next';

i18next.addResources('en', 'AdelphiStatements', {
  newStatement: 'Create a new statement',
  periodId: 'Period ID',
  mashingAndFermentation: 'Mashing and Fermentation',
  spiritAndFeints: 'Spirit and Feints',
  download: 'Download',
  delete: 'Delete'
});
